import { Box, styled } from "@mui/material";
import WEthIcon from "assets/icons/tokens/weth.avif";
import SolanaIcon from "assets/icons/chains/solana.png";
import EthereumIcon from "assets/icons/chains/ethereum.png";
import BaseIcon from "assets/icons/chains/base.png";
import BeraIcon from "assets/icons/chains/bera.png";
import BscIcon from "assets/icons/chains/bsc.png";
import HyperLiquidIcon from "assets/icons/chains/hype.png";
import TronIcon from "assets/icons/chains/tron.png";
import AptosIcon from "assets/icons/chains/apt.png";
import SuiIcon from "assets/icons/chains/sui.png";
import LineaIcon from "assets/icons/chains/linea.png";
import SonicIcon from "assets/icons/chains/sonic.png";
import AbstractIcon from "assets/icons/chains/abstract.png";
import FantomIcon from "assets/icons/chains/ftm.png";
import PolygonIcon from "assets/icons/chains/matic.png";
import OptimismIcon from "assets/icons/chains/op.png";
import ArbitrumIcon from "assets/icons/chains/arb.png";
import AvalancheIcon from "assets/icons/chains/avax.png";
import DefaultAvatarIcon from "assets/icons/default-avatar.png";
import { Chain } from "chainConfigs";

const CHAIN_COLOR_MAP: Record<Chain, string> = {
  solana: "#232323",
  ethereum: "#6481E7",
  base: "#0052FF",
  berachain: "#FFD700",
  bsc: "#FFFFFF",
};

export const CHAIN_BADGE_MAP: Record<string, string> = {
  solana: SolanaIcon,
  ethereum: EthereumIcon,
  base: BaseIcon,
  berachain: BeraIcon,
  bsc: BscIcon,
  hyperliquid: HyperLiquidIcon,
  hype: HyperLiquidIcon,
  tron: TronIcon,
  aptos: AptosIcon,
  sui: SuiIcon,
  linea: LineaIcon,
  sonic: SonicIcon,
  abstract: AbstractIcon,
  fantom: FantomIcon,
  ftm: FantomIcon,
  polygon: PolygonIcon,
  matic: PolygonIcon,
  optimism: OptimismIcon,
  op: OptimismIcon,
  arbitrum: ArbitrumIcon,
  arb: ArbitrumIcon,
  avax: AvalancheIcon,
  avalanche: AvalancheIcon,
};

export const NATIVE_TOKEN_MAP: Record<string, string> = {
  SOL: SolanaIcon,
  WSOL: SolanaIcon,
  ETH: EthereumIcon,
  WETH: WEthIcon,
  BERA: BeraIcon,
  BNB: BscIcon,
};

const CoinContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const TokenImage = styled("img")<{ chain?: Chain; size: "sm" | "md" }>(
  ({ theme, chain, size }) => ({
    width: size === "sm" ? theme.spacing(5) : theme.spacing(10),
    height: size === "sm" ? theme.spacing(5) : theme.spacing(10),
    borderRadius: "50%",
    objectFit: "cover",
    objectPosition: "center",
    border: `1px solid ${chain ? CHAIN_COLOR_MAP[chain] : theme.palette.border.dark}`,
    background: theme.palette.surface.container,
  }),
);

const ChainBadge = styled("img")<{ size: "sm" | "md" }>(({ theme, size }) => ({
  position: "absolute",
  top: size === "sm" ? theme.spacing(-0.1) : theme.spacing(-0.5),
  right: size === "sm" ? theme.spacing(-0.5) : theme.spacing(-0.5),
  width: size === "sm" ? theme.spacing(2) : theme.spacing(3),
  height: size === "sm" ? theme.spacing(2) : theme.spacing(3),
}));

type CoinAvatarProps = {
  iconUri: string;
  alt?: string;
  chain?: Chain;
  size?: "sm" | "md";
  style?: React.CSSProperties;
  badgeStyle?: React.CSSProperties;
};

const CoinAvatar = ({ iconUri, alt, chain, size = "sm", style, badgeStyle }: CoinAvatarProps) => {
  const handleOnError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    event.currentTarget.src = DefaultAvatarIcon;
  };
  return (
    <CoinContainer>
      <TokenImage
        src={iconUri}
        alt={alt}
        chain={chain}
        size={size}
        onError={handleOnError}
        style={style}
      />
      {chain && (
        <ChainBadge src={CHAIN_BADGE_MAP[chain]} alt={chain} size={size} style={badgeStyle} />
      )}
    </CoinContainer>
  );
};

export default CoinAvatar;
